import { feedTicker, newsFeed } from "@/mocks/homeData";

export default function NewsFeed() {
  const tickerItems = [...feedTicker, ...feedTicker];

  return (
    <section id="feed" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-secondary-700 md:text-sm">
              <i className="ri-live-line"></i>
              LIVE FEED
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-5xl">快讯流</h2>
            <p className="mt-4 max-w-xl text-sm leading-loose text-foreground-600 md:text-base">
              按时间倒序记录每一次线索更新与材料补充，从最新一条往下看，就能顺着节点把整件事的脉络走完。
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 overflow-hidden border-y border-background-200 bg-background-50 py-3">
        <div className="hl-marquee-track flex w-max items-center gap-10 whitespace-nowrap">
          {tickerItems.map((text, index) => (
            <span key={`${text}-${index}`} className="flex items-center gap-3 text-xs text-foreground-600 md:text-sm">
              <i className="ri-flashlight-fill text-accent-500"></i>
              {text}
            </span>
          ))}
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-3xl px-4 md:px-8">
        <ol className="relative border-l border-background-300 pl-6 md:pl-10">
          {newsFeed.map((item, index) => (
            <li key={item.id} className={index === newsFeed.length - 1 ? "relative pb-0" : "relative pb-10 md:pb-12"}>
              <span
                className={`absolute -left-[31px] top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 md:-left-[47px] ${
                  index === 0
                    ? "hl-pulse-dot border-primary-500 bg-primary-500"
                    : "border-background-300 bg-background-50"
                }`}
              ></span>

              <div className="flex flex-wrap items-center gap-3">
                <span className="font-heading text-xl font-black tabular-nums text-foreground-900 md:text-2xl">
                  {item.time}
                </span>
                <span className="rounded-full bg-background-200/70 px-2.5 py-0.5 text-[11px] font-medium text-foreground-600">
                  {item.day}
                </span>
                <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                  {item.tag}
                </span>
              </div>

              <a href="#materials" className="group mt-3 block cursor-pointer">
                <h3 className="text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-loose text-foreground-600">{item.summary}</p>
                <span className="mt-3 flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-links-line"></i>
                  来源 · {item.source}
                </span>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}